module.exports = __webpack_public_path__ + "img/21.8fba2a1b.jpg";